import tinycolor from 'tinycolor2'

export default {
  methods: {

    // Check if a colour is a light colour (as opposed to dark)
    // Used to display dark text over light colours
    // @param Colour A hex based string (with leading hash)
    isColourLight(colour, thresholdBrightness = 160) {
      // Note: tinycolor uses 128 as the threshold for light/dark, but it doesn't look as nice

      return tinycolor(colour).getBrightness() > thresholdBrightness
    },

    // Return a text colour given a background colour
    // Adjusts for light/dark backgrounds to make the text most legible
    textColourForBackground(bgColour, thresholdBrightness = 160) {
      return this.isColourLight(bgColour, thresholdBrightness) ? '#202020' : '#ffffff'
    },


    /**
     * Lighten a colour string by a percentage between 0 -> 100
     * 
     * @param {String} colour - Hex based string (with leading hash)
     * @param {Number} amount - Amount to lighten by. Valid range is 0 - 100
     * @return {String} Returns a hex based string for the resulting colour
     */
    lightenColour(colour, amount) {
      return tinycolor(colour).lighten(amount).toString()
    },


    /**
     * Darken a colour string by a percentage between 0 -> 100
     * 
     * @param {String} colour - Hex based string (with leading hash)
     * @param {Number} amount - Amount to darken by. Valid range is 0 - 100
     * @return {String} Returns a hex based string for the resulting colour
     */
    darkenColour(colour, amount) {
      return tinycolor(colour).darken(amount).toString()
    },


    /**
     * Desaturate a colour string by a percentage between 0 -> 100
     * 
     * @param {String} colour - Hex based string (with leading hash)
     * @param {Number} amount - Amount to darken by. Valid range is 0 - 100
     * @return {String} Returns a hex based string for the resulting colour
     */
    desaturateColour(colour, amount) {
      return tinycolor(colour).desaturate(amount).toString()
    },
  }
}
